import React from 'react';
import PdfEmbed from '../pdf-embed/pdf-embed';
import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { EmbedElementProps } from './embed-element.types';
import { H2Atom, PAtom } from '../../atoms/text-atoms/text-atoms';
import { sectionTitleBorder } from '../../mixins';

const EmbedElement: React.FC<EmbedElementProps> = ({
  embedId,
  titleCmsOnly,
  title,
  displayTitle,
  description,
  url,
  className,
  isFullWidth,
  id,
}) => {
  if (url) {
    return (
      <div className={className} id={id || ''}>
        {title && <H2Atom>{title}</H2Atom>}
        {description && <PAtom>{description}</PAtom>}
        <PdfEmbed
          className="pdf-embed"
          embedId={embedId}
          url={url}
          title={title}
          displayTitle={displayTitle}
        />
      </div>
    );
  } else {
    console.warn(`embed-element called with missing url: ${titleCmsOnly}`);
    return null;
  }
};

const StyledEmbedElement = styled(EmbedElement)`
  ${H2Atom} {
    margin-bottom: ${vars.spacingM};
    ${({ colour }) => sectionTitleBorder(colour)};

    ${({ isFullWidth }) =>
      isFullWidth &&
      `
      padding: 0 1.2rem;
    `}
  }
  ${PAtom} {
    margin-bottom: ${vars.spacingM};

    ${({ isFullWidth }) =>
      isFullWidth &&
      `
      padding: 0 1.2rem;
    `}
  }
  height: 100%;
  .pdf-embed {
    border: none;
    width: 100%;
    height: 100%;
  }
`;

export default StyledEmbedElement;
